import { AngularFirestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CitiesService {

  countriesRef = 'countries';
  citiesRef = 'cities';

  constructor(
    private angularFirestore: AngularFirestore
  ) { }

  /** Retorna todos los paises */
  getCountries() {
    return this.angularFirestore.collection<any>(
      this.countriesRef
    ).snapshotChanges().pipe(
      map( countries => {
        return countries.map( country => {
          const data = country.payload.doc.data();
          const id = country.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  /** Retorna todas las ciudades */
  getCities() {
    return this.angularFirestore.collection<any>(
      this.citiesRef
    ).snapshotChanges().pipe(
      map( cities => {
        return cities.map( city => {
          const data = city.payload.doc.data();
          const id = city.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

  /** Retorna todas las ciudades filtradas por país */
  getCitiesByCountry(country: string) {
    return this.angularFirestore.collection<any>(
      this.citiesRef, ref => ref.where('country', '==', country)
    ).snapshotChanges().pipe(
      map( cities => {
        return cities.map( city => {
          const data = city.payload.doc.data();
          const id = city.payload.doc.id;
          return { id, ...data };
        });
      })
    );
  }

}
